export default "__VITE_PUBLIC_ASSET__2196300f__"